var _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1626",
    "data-name": "Group 1626",
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.664,
    height: 35.339,
    viewBox: "0 0 82.664 35.339",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2103",
    "data-name": "Path 2103",
    d: "M368.966,317.819l-2.9-4.458h-2.9v4.458h-3.805V302.43h6.684c3.8,0,6.343,2.084,6.343,5.41a5.15,5.15,0,0,1-2.585,4.591l3.6,5.387Zm-5.8-7.9h2.813c1.463,0,2.609-.816,2.609-2.082,0-1.245-1.146-2.036-2.609-2.036h-2.812Z",
    transform: "translate(-341.569 -282.774)",
    fill: "#e11931"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2104",
    "data-name": "Path 2104",
    d: "M403.779,305.758v2.805h6.793v3.26h-6.793v2.67h7.762v3.326H399.974V302.43h11.566v3.328Z",
    transform: "translate(-366.284 -282.774)",
    fill: "#e11931"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2105",
    "data-name": "Path 2105",
    d: "M450.437,310.082c0,4.57-3.439,7.736-8.253,7.736h-6.145V302.43h6.145c4.815,0,8.253,3.146,8.253,7.652m-3.847,0a4.239,4.239,0,0,0-4.407-4.212h-2.341v8.508h2.341a4.27,4.27,0,0,0,4.407-4.3",
    transform: "translate(-388.23 -282.774)",
    fill: "#e11931"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1549",
    "data-name": "Rectangle 1549",
    width: 3.805,
    height: 15.388,
    transform: "translate(64.299 19.656)",
    fill: "#e11931"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2106",
    "data-name": "Path 2106",
    d: "M505.554,305.85h-4.387v11.97h-3.78V305.85H493v-3.419h12.556Z",
    transform: "translate(-422.89 -282.775)",
    fill: "#e11931"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    d: "M325.513,311.822a3.573,3.573,0,0,1-3.519,2.259,4.419,4.419,0,0,1,0-8.829,3.573,3.573,0,0,1,3.519,2.257h4.028a7.356,7.356,0,0,0-7.524-5.834,7.99,7.99,0,1,0,0,15.978,7.355,7.355,0,0,0,7.524-5.832Z",
    transform: "translate(-313.919 -282.315)",
    fill: "#e11931"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2108",
    "data-name": "Path 2108",
    d: "M330.044,253.952V269.34h-3.782v-5.771h-6.23v5.771h-3.8V253.952h3.8v6.179h6.23v-6.179Z",
    transform: "translate(-315.326 -253.275)",
    fill: "#e11931"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2109",
    "data-name": "Path 2109",
    d: "M437.507,269.339h-3.8v-7.716l-3.4,5.273v.02h-2.115v-.02l-3.418-5.32.02,7.763H421V253.951h2.833l5.422,8.214,5.421-8.214h2.835Z",
    transform: "translate(-379.076 -253.274)",
    fill: "#e11931"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2110",
    "data-name": "Path 2110",
    d: "M475.031,257.278v2.805h6.8v3.261h-6.8v2.667h7.762v3.328H471.229V253.952h11.564v3.326Z",
    transform: "translate(-409.643 -253.275)",
    fill: "#e11931"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    "data-name": "Path 2111",
    d: "M369.225,252.222a10.732,10.732,0,0,0-10.953,10.5,10.136,10.136,0,0,0,1.665,5.568h5.283a6.651,6.651,0,1,1,8.01,0h5.285a10.13,10.13,0,0,0,1.665-5.568,10.73,10.73,0,0,0-10.955-10.5",
    transform: "translate(-340.908 -252.222)",
    fill: "#e11931"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2112",
    "data-name": "Path 2112",
    d: "M377.075,283.429a3.761,3.761,0,0,0,7.182,0Z",
    transform: "translate(-352.35 -271.212)",
    fill: "#e11931"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.ce6ca741e8cc07c4e37e7cc514375c1f.svg";
export { ForwardRef as ReactComponent };